import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { superAdminApi } from '../api/superAdminApi';

export function useSuperAdminVendors(params) {
  return useQuery({
    queryKey: ['superadmin', 'vendors', params],
    queryFn: () => superAdminApi.getVendors(params),
    keepPreviousData: true,
  });
}

export function useUpdateVendorVerification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ vendorId, isVerified }) => superAdminApi.updateVendorVerification(vendorId, isVerified),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['superadmin', 'vendors'] }),
  });
}

export function useUpdateVendorCommission() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ vendorId, commissionRate }) => superAdminApi.updateVendorCommission(vendorId, commissionRate),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['superadmin', 'vendors'] }),
  });
}

export function useUpdateVendorReferral() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ vendorId, referralEnabled }) =>
      superAdminApi.updateVendorReferral(vendorId, referralEnabled),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['superadmin', 'vendors'] }),
  });
}

export function useDeleteVendor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vendorId) => superAdminApi.deleteVendor(vendorId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['superadmin', 'vendors'] }),
  });
}